import React, { useState, useEffect, useRef } from 'react'
import { Row, Col, Card, CardHeader, CardBody,Input,Button } from "reactstrap";
import { useGetOverlapDataQuery } from 'features/dashboard/RiskManagement/RiskManagementApiSlice';
import { Spinner } from 'react-bootstrap';
import Tooltip from '@mui/material/Tooltip';
import CancelIcon from '@mui/icons-material/Cancel';
import Skeleton from 'react-loading-skeleton'
import WizardOverlap from './WizardOverlap';
const ProjectAcerageOverlap = ({districtCrop,kharifCrop,RabiCrop,setShowOverlapArea,setShowLoading,showLoading,blockName,selectedLanguage,showOverlapArea}) => {
    const iRef = useRef()
    const { data: overlapData,refetch,isLoading } = useGetOverlapDataQuery({districtCrop,kharifCrop,RabiCrop})

    const [OverlapResponse, setOverlapResponse] = useState([])
    const [LulcHistogramData, setLulcHistogramData] = useState("")
  

    useEffect(() => {
       
        if (!isLoading && overlapData && showOverlapArea) {

            setOverlapResponse(overlapData?.data)
            if(overlapData?.data?.summary_statistic && JSON.stringify(overlapData?.data?.summary_statistic) !== `{}`){
                setShowLoading(false)

                setLulcHistogramData(JSON.parse(overlapData?.data?.summary_statistic))
                }
    }
    // if (isLoading || showLoading) {
    //     setShowLoading(true)
    // }
    }, [overlapData,districtCrop,kharifCrop,RabiCrop,isLoading])

//   useEffect(()=>{
//     console.log("enterimg  ------firsttime")

//     if(districtCrop && kharifCrop && RabiCrop)

//         {
//             console.log("enterimg all data is there",districtCrop,"--",kharifCrop,"--",RabiCrop)
//             refetch({districtCrop:districtCrop,kharifCrop:kharifCrop,RabiCrop:RabiCrop})
//         }
//  },[districtCrop,kharifCrop,RabiCrop])





 useEffect(() => {
    if (!iRef) return

    if (iRef.current && OverlapResponse) {
        const iframe = iRef.current;
        iframe.contentWindow.postMessage(OverlapResponse, 'https://updasp.agrani.tech');
    }
}, [iRef.current, OverlapResponse]);

useEffect(() => {
    if (!iRef) return

    if (iRef.current) {
        const iframe = iRef.current;
        const handleMessage = (e) => {
            if (e.data === "ready") {
                iframe.contentWindow.postMessage(OverlapResponse, 'https://updasp.agrani.tech');
            }
        };
        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }
}, [iRef.current, OverlapResponse]);

    window.addEventListener("message", (e) => { })
   const handleOverlapArea=()=>{
    setShowOverlapArea(false)
    setShowLoading(true)
   }
    return (
        <div className='row mt-2'>
        <div >
        <Tooltip title="Clear" arrow>
        <Button style={{backgroundColor:"transparent",border:"1px solid transparent",color:"black",padding:"6px",float:"inline-end",marginLeft:"3px"}} >        
        <CancelIcon fontSize="small" style={{ color: "#575656", float: "inline-end" }}  className="cursor-pointer" onClick={()=>handleOverlapArea()}/>
        </Button>
        </Tooltip>
        </div>
        <div className='col-lg-3'>
        <WizardOverlap LulcHistogramData={LulcHistogramData} showLoading={showLoading} selectedLanguage={selectedLanguage}/>
        </div>
       
            <div className='col-lg-9 mt-1'>
                <Card className=''>
                {isLoading?<Skeleton count={13} height="25px" />:<>
                    <CardBody className='content p-3'  style={{ backgroundColor: "#F5F5F5" }}>
                        <iframe id="frame1" ref={iRef} src="https://updasp.agrani.tech/?#clean"
                            width="100%" frameborder="0" height="100%"
                            sandbox="allow-same-origin allow-scripts"

                        ></iframe>
                    </CardBody>
                    </>
    }
                </Card>
            </div>
        </div>
    )
}

export default ProjectAcerageOverlap

